export const IS_ADMIN_ENFORCING_MFA_SUCCESS = 'IS_ADMIN_ENFORCING_MFA_SUCCESS';
export const IS_ADMIN_ENFORCING_MFA_FAILED = 'IS_ADMIN_ENFORCING_MFA_FAILED';
export const GET_USERS_LOADING = 'GET_USERS_LOADING';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';
